import React, { useContext } from "react";
import AuthContext from "../../Context/AuthContext";

const UserProfileIcon = ({ userName, onClick }) => {
    const { user } = useContext(AuthContext);
    const profileImage = user?.PROFILEIMAGE;

    return (
        <button onClick={onClick} className="UserLog_Reg d-flex align-items-center gap-2 border-0 bg-transparent">
            <img
                className="headerProfileImage"
                src={profileImage || "/assets/images/users/userprofile.jpg"}
                alt="User Icon"
                style={{ width: '35px', height: '35px', borderRadius: '50%', objectFit: 'cover' }}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/assets/images/users/userprofile.jpg";
                }}
            />
        </button>
    );
};

export default UserProfileIcon;